<div class="scrollable-y m-15 manage-apps-page">
  <div class="row">
    <div class="col-md-12">
      <div class="pages-header">
        <h1 class="mobile-move-title">Manage Available Apps</h1>
      </div>
      <div class="panel panel-default">
        <div class="panel-body">
          <div class="manage-apps-list" style="margin-top: 20px">
            <div class="row">
              <div class="col-12">
                <div style="display: inline-block">
                  <span>
                    <!-- <h4 class="manage-apps-filter"><span class="library-name">{{current_library.name}}</span> <i class="feather chevron-down"></i></h4> -->
                    <h4 class="manage-apps-filter" style="cursor: default">
                      <span class="library-name">Available Apps</span>
                      <!--<i class="feather chevron-down"></i>-->
                    </h4>
                  </span>
                  <!-- <ul *dropdownMenu class="dropdown-menu" role="menu" style="left:15px;top:30px">
                                        <li role="menuitem" (click)="change_library('global')"><a class="dropdown-item">Global Library</a></li>
                                        <li role="menuitem" (click)="change_library('practice')"><a class="dropdown-item">Practice Library</a></li>
                                    </ul> -->
                </div>
                <div class="manage-apps-search">
                  <i class="feather search"></i>
                  <input
                    type="text"
                    [(ngModel)]="search"
                    placeholder="Search in Apps"
                  />
                </div>
              </div>
              <!-- <div class="col-6 text-right">
                                <div class="manage-apps-order" dropdown placement="bottom right">
                                    <span dropdownToggle>
                                        Sort by <span class="sort-by">Recently Used</span> <i class="feather chevron-down"></i>
                                    </span>
                                    <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                                        <li role="menuitem"><a class="dropdown-item">Recently Used</a></li>
                                        <li role="menuitem"><a class="dropdown-item">Alphabetical Order</a></li>
                                    </ul>
                                </div>
                            </div> -->
            </div>
            <!-- <p>Click on an App to add login credentials to enable quick-login. You can also add or edit
                            information for Practice Library apps.</p> -->
            <nav class="default-tabs tabs">
              <div class="tabs-wrapper" style="padding-left: 0">
                <a
                  [ngClass]="{
                    active: current_library.name == 'Practice Library'
                  }"
                  (click)="change_library('practice')"
                  >Firm Library</a
                >
                <a
                  [ngClass]="{
                    active: current_library.name == 'Global Library'
                  }"
                  (click)="change_library('global')"
                  >Client Hub Library</a
                >
              </div>
            </nav>
            <div class="library scrollbars">
              <div
                class="manage-apps-card new-app"
                (click)="openModal($event, template_add)"
                *ngIf="current_library.name == 'Practice Library'"
              >
                <i class="feather plus x3"></i>
                <div class="app-name">New App</div>
              </div>
              <div
                class="manage-apps-card"
                style="margin-bottom: 15px"
                *ngFor="
                  let app of current_library.bucket | appSearch : search;
                  let i = index
                "
                (click)="openModal($event, template_edit, app)"
              >
                <i
                  class="manage-apps-icon feather package"
                  placement="top"
                  tooltip="Global library"
                ></i>

                <img
                  title="{{ app.name }}"
                  *ngIf="app.company == null"
                  src="{{ app.logo }}"
                  alt="{{ app.name }}"
                  class="manage-apps-logo"
                />
                <img
                  title="{{ app.name }}"
                  *ngIf="app.company != null"
                  src="{{
                    app.logo == null ? 'assets/img/logos/default.png' : app.logo
                  }}"
                  alt="{{ app.name }}"
                  class="manage-apps-logo"
                />
                <div class="app-name" title="{{ app.name }}">
                  {{ app.name }}
                </div>
                <div class="app-description" title="{{ app.category }}">
                  {{ app.category }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-resources-page></app-resources-page>
</div>
